<template>
  <v-snackbar v-model="snackbar" :timeout="timeout" :color="color">
    {{ text }}

    <template v-slot:action="{ attrs }">
      <v-btn
        icon
        v-bind="attrs"
        color="secondaryText"
        @click="snackbar = false"
      >
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  data() {
    return {
      snackbar: false,
      text: 'Erro',
      timeout: 6000,
      color: 'error',
    }
  },
  computed: {
    ...mapGetters(['snackbarContent']),
  },
  watch: {
    snackbarContent(v) {
      this.timeout = v.timeout || 6000
      this.text = v.message ? v.message : 'Erro'
      this.color = v.color ? v.color : 'error'
      this.snackbar = true
    },
  },
}
</script>

<style></style>
